import { ApiProperty } from "@nestjs/swagger";

export class RejectionRequest{
    @ApiProperty()
    rejectionId:number;
}